import React from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';

const MetricCard = ({ icon: Icon, value, suffix = '', label, color = 'primary', index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      className="p-4 sm:p-6 lg:p-8 flex flex-col items-center justify-center text-center border-b md:border-b-0 md:border-r last:border-r-0 border-white/5 bg-gradient-to-br from-white/5 to-transparent hover:from-white/10 transition-colors group cursor-default"
    >
      <div className={`text-${color} mb-2 opacity-80 group-hover:opacity-100 transition-opacity`}>
        {Icon && <Icon className="w-8 h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10" />}
      </div>
      <p className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-white mb-1 sm:mb-2 font-heading">
        {suffix === '+' && '+'}
        <CountUp end={parseInt(value)} duration={2.5} separator="," />
        {suffix !== '+' && suffix}
      </p>
      <p className="text-xs sm:text-sm font-medium text-gray-400 uppercase tracking-widest">
        {label}
      </p>
    </motion.div>
  );
};

export default MetricCard;
